module.exports = __webpack_public_path__ + "img/task_demo_en.34ae0c07.png";